import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing, palette }) => ({
  box: {
    maxWidth: spacing(450),
    width: spacing(450),
    boxSizing: 'border-box',
  },
  header: {
    padding: spacing(23, 32),
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gridColumnGap: spacing(12),
    alignItems: 'center',
  },
  content: {
    padding: spacing(24, 32, 32),
    boxSizing: 'border-box',
  },
  rejectIcon: {
    height: spacing(32),
    width: spacing(32),
  },
  title: {
    fontWeight: 'bold',
    color: palette.gray[80],
  },
  close: {
    height: spacing(14),
    width: spacing(14),
  },
  divider: {
    backgroundColor: palette.gray[12],
  },
}))
